<template>
    <span class="avatar-or-initials">
        <div v-if="correspondent.imageUrl" :style="imageStyles" alt="Avatar image"></div>
        <initials v-else :width="width" :font-size="fontSize" :first-name="correspondent.firstName" :last-name="correspondent.lastName"></initials>
    </span>
</template>

<script>
    import Initials from "../../../components/customer/Initials.vue";

    export default {
        name: "AvatarOrInitials",
        components: { Initials },
        props: {
            correspondent: { type: Object, required: true },
            width: { type: String, default: "2.5rem" },
            fontSize: { type: String, default: "1rem" }
        },

        computed: {
            imageStyle() {
                return `width: ${this.width}; height: ${this.width}`
            },
            
            imageStyles() {
            	return {
            		backgroundImage: `url("${this.correspondent.imageUrl}")`,
            		backgroundRepeat: "no-repeat",
	        	    backgroundSize: "cover",
	        	    backgroundPosition: "center",
	        	    width: `${this.width}`,
	        	    height: `${this.width}`,
	        	    borderRadius: `${this.width}`
            	}
            }
        }
    }
</script>

<style scoped>

</style>